export const hyperliquidAccountCategory = 'hyperliquid'

export const networkEvmChainIds: Record<string, number | undefined> = {}

export const networkPolkadotChainIds: Record<string, number | undefined> = {}

export const solanaNetwork = undefined
